import { dehydrate } from 'react-query/hydration'
import { setSession } from 'utils/set-session'
import {
  getPaymentStatusService,
  getPaymentCountryService,
} from 'services/payment'
import InternalError from 'errors/internal-error'
import NotFound from 'errors/not-found'
import CheckoutLayout from 'checkout/checkout-layout'
import { getCourseService } from 'services/course'
import { QueryClient } from 'react-query'
import { prefetchPaymentConfig } from 'querys/payment'
import { prefetchCourse, useCourseWithSavedCoupon } from 'querys/course'
import { useRouter } from 'next/router'
import { prefetchCouponStatus } from 'querys/coupons'

function CheckoutCourse() {
  const router = useRouter()
  const { data: course, isError } = useCourseWithSavedCoupon()
  if (!course) return null
  if (course?.is_free) {
    router.push('/aprender')
    return null
  }
  if (course.statusCode === 404) {
    return <NotFound />
  }
  if (isError) {
    return <InternalError />
  }

  const { title, slug, meta, price, original_price, badge, discount } = course
  const originalPrice = discount?.status === 'VALID' ? original_price : {}

  return (
    <CheckoutLayout
      title={title}
      url={`https://leonidasesteban.com/comprar/cursos/${slug}`}
      description={meta}
      price={price}
      originalPrice={originalPrice}
      courseImg={badge?.image}
      type="singleCourse"
    />
  )
}

CheckoutCourse.pageTheme = {
  background: 'var(--sky)',
}

export const getServerSideProps = async ({
  res, query, req,
}) => {
  const queryClient = new QueryClient()
  const { token } = setSession(req, queryClient)
  const { course, coupon_code, single_coupon } = query

  const coupon = single_coupon || coupon_code
  const random = await getCourseService({
    course_slug: course, token: '',
  })

  if (random.is_free) {
    res.writeHead(302, { Location: `/aprender/${course}` })
    res.end()
    return { props: {} }
  }
  if (token) {
    try {
      const { has_access } = await getPaymentStatusService({
        course_slug: course, token, res, req,
      })
      if (has_access) {
        res.writeHead(302, { Location: `/aprender/${course}` })
        res.end()
      }
    } catch ({ message }) {
      if (message === 'User Unauthorized') {
        const { url } = req
        res.setHeader('Set-Cookie', 'user_token=deleted; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT')
        res.setHeader('Set-Cookie', 'user_payload=deleted; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT')
        res.writeHead(302, {
          location: `/login?next=${url}`,
        })
        res.end()
      }
    }
  }

  let country = ''
  const ip = req.headers['x-forwarded-for'] || req.connection.remoteAddress
  const { headers: { host } } = req
  if (host.includes('localhost') || host.includes(':3000')) {
    country = 'MX'
  } else {
    const data = await getPaymentCountryService({ ip })
    queryClient.setQueryData('GET_COUNTRY_CODE', data)
    country = data.countryCode
  }

  await prefetchCourse({
    slug: course,
    client: queryClient,
    token,
    country,
  })
  if (coupon) {
    await prefetchCouponStatus({
      queryClient, coupon_code: coupon, course, countryCode: country,
    })
  }
  await prefetchPaymentConfig(queryClient, country)

  return {
    props: {
      course_slug: course,
      dehydratedState: dehydrate(queryClient),
    },
  }
}


export default CheckoutCourse
